module.exports = __webpack_public_path__ + "img/export.3046a7b1.svg";